export type PipelineStage = 'extract' | 'transform' | 'load'

/** Per-stage accent classes (tokenized: extract=warning, transform=info, load=success). */
export const STAGE_TONE: Record<
  PipelineStage,
  { dot: string; icon: string; iconBg: string; hover: string }
> = {
  extract: {
    dot: 'bg-warning',
    icon: 'text-warning',
    iconBg: 'bg-warning/10',
    hover: 'hover:border-warning/50',
  },
  transform: {
    dot: 'bg-info',
    icon: 'text-info',
    iconBg: 'bg-info/10',
    hover: 'hover:border-info/50',
  },
  load: {
    dot: 'bg-success',
    icon: 'text-success',
    iconBg: 'bg-success/10',
    hover: 'hover:border-success/50',
  },
}
